document.addEventListener("DOMContentLoaded", function (event) {
  var btn = document.getElementById('toTopButton');

  // if (btn) {
  //   if (navigator.appVersion.indexOf("Chrome/") !== -1) {
  //     btn.classList.add("mb-0");
  //   }
  // }

  function toTop() {
    // console.log("totop")
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  // function hide() {
  //   setTimeout(function () {
  //     btn.style.display = "none";
  //   }, 300);
  // }
  //
  // function show() {
  //   setTimeout(function () {
  //     btn.style.display = "flex";
  //   }, 300);
  // }

  function scrollFunction() {
    // console.log('scroll')
    if (document.body.scrollTop > 814 || document.documentElement.scrollTop > 814) {
      btn.style.display = "flex";
      // btn.style.opacity = "1";
      // btn.removeEventListener('click', function handleClick() {
      //   toTop();
      // });
      // show();
    } else {
      // btn.style.opacity = "0";
      // btn.removeEventListener('click', function handleClick() {
      //   toTop();
      // });
      // hide();
      // setTimeout(function () {
      btn.style.display = "none";
      // }, 300);
    }

    // if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
    //   btn.style.display = "flex";
    // } else {
    //   btn.style.display = "none";
    // }

  }

  btn.addEventListener('click', function handleClick() {
    toTop();
  });

  window.onscroll = function () {
    scrollFunction()
  };
});
